export default "__VITE_ASSET__kYq9BDSD__"